module.exports = __webpack_public_path__ + "img/add_icon.3361e922.svg";